import React, { useState } from 'react';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from '../../../contexts/translation';
import { Lang, TranslateLang } from '../../../types/core/lang.types';

interface Props {
  onClose: () => void;
}

export function LanguageChangerModal({ onClose }: Props) {
  const { t, changeLang, lang, supportedLanguages } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(lang);

  if (!supportedLanguages) return <>No supported languages</>;
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormControl>
          <InputLabel id="demo-simple-select-label">
            {t('general.inputs.dropdown-language')}
          </InputLabel>
          <Select
            label={t('general.inputs.dropdown-language')}
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value as Lang)}
            sx={{ minWidth: 150 }}
          >
            {supportedLanguages?.map((lang: any, index: any) => (
              <MenuItem value={lang} key={index}>
                {t(TranslateLang[lang as Lang])}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant="contained"
          onClick={() => {
            changeLang(selectedLanguage), onClose();
          }}
        >
          {t('general.action-buttons.apply')}
        </Button>
      </Grid>
    </Grid>
  );
}
